<template>
  <div class="result-list">
    <header-title title="結果一覧" />

    <!-- カラダカルテ -->
    <div class="result-list--items">
      <heading title="カラダカルテ" />
      <!-- リスト -->
      <div
        v-for="(date, index) in diagnosisDate"
        :key="index"
        class="result-list--items--item"
        @click="toKaradaKarte(date)"
        :data-test="`karte-${date}`"
      >
        <span>{{ date | formateDate }}</span>
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>

    <!-- AI疾病予測結果 -->
    <div class="result-list--items">
      <heading title="AI疾病予測" />
      <!-- リスト -->
      <router-link to="/report" class="link">
        <div
          v-for="(date, index) in diagnosisDate"
          :key="index"
          class="result-list--items--item"
          @click="
            $store.dispatch('selvy/setDiagnosisDate', {
              date: date
            })
          "
          :data-test="`report-${date}`"
        >
          <span>{{ date | formateDate }}</span>
          <i class="fas fa-chevron-right"></i>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "@/design/HeaderTitleSlot.vue";
import Heading from "@/components/atoms/Heading.vue";

export default {
  components: {
    Heading,
    HeaderTitle
  },
  data() {
    return {
      diagnosisDate: []
    };
  },
  methods: {
    toKaradaKarte(date) {
      this.$router.push({
        name: "karadaKarte",
        params: {
          date: date
        }
      });
    }
  },
  computed: {
    getDiagnosisDate() {
      return Object.keys(this.$store.state.karte.karteData);
    }
  },
  created() {
    this.diagnosisDate = this.$store.getters["karte/getKarteDateList"];
  },
  filters: {
    formateDate(yyyymmdd) {
      return (`${yyyymmdd.substr(0, 4)}/${yyyymmdd.substr(4, 2)}/${yyyymmdd.substr(6, 2)}`)
    }
  }
};
</script>

<style scoped>
.result-list {
  width: 60%;
  margin-top: 20px;
}
.result-list--items {
  margin-top: 20px;
}
.result-list--items >>> .heading {
  text-align: center;
}
.result-list--items--item {
  padding: 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e3e3e3;
  color: #9c9a9a;
  font-weight: bold;
}
.result-list--items--item:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.03);
}
.link {
  text-decoration: none;
}
</style>
